import http from '../../../http/http';
import router from '../../../router';

const state = {
    loading: 0,
    jwt: '',
    userData: '',
    userList: '',
    userInfo: '',
    userToDel: 0,
    favtrains: [],
    anb: '',
    leaImg: 0,
    staos: [],
    stao10min: [],
    staoInfo: '',
    userMailList: []
};

const getters = {
    loading: (state) => state.loading,
    jwt: (state) => state.jwt,
    userData: (state) => state.userData,
    userList: (state) => state.userList,
    openUserInfo: (state) => state.openUserInfo,
    userInfo: (state) => state.userInfo,
    userToDel: (state) => state.userToDel,
    autLev: (state) => state.userData.autlev,
    favtrains: (state) => state.favtrains,
    anb: (state) => state.anb,
    terms: (state) => state.userData.terms,
    staos: (state) => state.staos,
    stao10min: (state) => state.stao10min,
    staoInfo: (state) => state.staoInfo,
    userStao: (state) => state.userData.stao,
    userMailList: (state) => state.userMailList

};

const mutations = {
    jwt: (state, payload) => {
        state.jwt = payload;
        // set the axios header with the JWT
        http.defaults.headers.common['Authorization'] = payload;
    },
    loading: (state, payload) => {
        state.loading = payload;
    },
    userData: (state, payload) => {
        state.userData = payload;
    },
    userList: (state, payload) => {
        state.userList = payload;
    },
    userInfo: (state, payload) => {
        state.userInfo = payload;
    },
    userToDel: (state, payload) => {
        state.userToDel = payload;
    },
    favtrains: (state, payload) => {
        state.favtrains = payload;
    },
    anb: (state, payload) => {
        state.anb = payload;
    },
    staos: (state, payload) => {
        state.staos = payload;
    },
    stao10min: (state, payload) =>{
        state.stao10min = payload;
    },
    staoInfo: (state, payload) => {
        state.staoInfo = payload;
    },
    userMailList: (state, payload) => {
        state.userMailList = payload;
    }
};

const actions = {
    jwt: ({ commit }, payload) => {
        commit('jwt', payload);
    },

    loadingstart: ({ commit }) => {
        state.loading = state.loading + 1;
    },
    loadingstop: ({ state }) => {
        state.loading = state.loading - 1;

        if (state.loading < 0) {
            state.loading = 0;
        }
    },
    loadingcancle: ({ commit }) => {
        commit('loading', 0);
    },
    getUserData: ({ commit, dispatch }, payload) => {
        // get the rest of the info
        http.get('/userInfo')
            .then((response) => {
                commit('userData', response.data);
            });
    },

    userData: ({ commit }, payload) => {
        commit('userData', payload);
    },

    userToDel: ({ commit }, payload) => {
        commit('userToDel', payload);
    },

    userInfo: ({ commit, dispatch }, payload) => {
        http.post('/userInfoFromId', { id: payload })
            .then((response) => {
                commit('userInfo', response.data);
                router.push({ name: 'userinfo' });
            });
    },

    userList: ({ commit, dispatch }, payload) => {
        http.post('/userList', payload)
            .then((response) => {
                commit('userList', response.data);
            });
    },

    login: ({ commit, dispatch }, payload) => {
        // post the login data
        http.post('/login', payload)
            .then((response) => {
                // commit the token to the jwt
                commit('jwt', response.data.token);

                // commit the rest of the data
                commit('userData', {
                    id: response.data.id,
                    email: response.data.email,
                    unum: response.data.unum,
                    fname: response.data.fname,
                    lname: response.data.lname,
                    stao: response.data.stao,
                    autlev: response.data.autlev,
                    terms: response.data.terms
                });

                // place the jwt into the local storage so you can get it when reloading the page
                localStorage.setItem('JWT', response.data.token);

                // set the menuItems
                dispatch('menu/menuItems', response.data.autlev, { root: true });

                // push the msg to the notifications
                dispatch('notifications/notification', {
                    msg: 'Welcome ' + response.data.fname,
                    error: false,
                    time: 2000
                }, { root: true });

                // goto path
                router.push(payload.path);

                dispatch('setLastTime');
            });
    },

    logout: ({ commit }) => {
        commit('jwt', '');
        commit('userData', '');
        // get rid of the jwt in the localstorage
        localStorage.removeItem('JWT');
        // go to the login page
        router.push('/');
    },

    saveNewUserData: ({ commit, dispatch, state }, payload) => {
        // add the id to the new payload
        payload.new.id = payload.old.id;

        // check if the password is the same as the rewritten password
        if (payload.new.pw === payload.new.rpw) {
            // if the unum has changed
            if (payload.new.unum.toUpperCase() !== payload.old.unum.toUpperCase()) {
                // check if the Unum is already in use
                http.post('/checkUnum', {
                    unum: payload.new.unum
                })
                    .then((response) => {
                        // if something came back that means that the unum is already in use
                        if (response.data.length < 1) {
                            // email address
                            if (payload.old.email.toUpperCase() !== payload.new.email.toUpperCase() && payload.new.email !== '') {
                                var data = {
                                    address: payload.new.email,
                                    fname: payload.new.fname
                                }
                                payload.new.email = payload.old.email;

                                http.post('sendEmailVerificationMail', data)
                                    .then((response) => {
                                        dispatch('notifications/notification', {
                                            msg: response.data,
                                            error: false,
                                            time: 2000
                                        }, { root: true });
                                    });
                            }

                            // change the userinfo
                            http.post('changeUserInfo', payload.new)
                                .then((response) => {
                                    dispatch('notifications/notification', {
                                        msg: response.data,
                                        error: false,
                                        time: 2000
                                    }, { root: true });

                                    dispatch('userList');
                                });
                        } else {
                            dispatch('notifications/notification', {
                                msg: 'U number already in use',
                                error: true,
                                time: 2000
                            }, { root: true });
                        }
                    });
            } else {
                // email address
                if (payload.old.email.toUpperCase() !== payload.new.email.toUpperCase() && payload.new.email !== '') {
                    var data = {
                        address: payload.new.email,
                        fname: payload.new.fname
                    }

                    payload.new.email = payload.old.email;

                    http.post('sendEmailVerificationMail', data)
                        .then((response) => {
                            dispatch('notifications/notification', {
                                msg: response.data,
                                error: false,
                                time: 2000
                            }, { root: true });
                        });
                }

                // change the userinfo
                http.post('changeUserInfo', payload.new)
                    .then((response) => {
                        dispatch('notifications/notification', {
                            msg: response.data,
                            error: false,
                            time: 2000
                        }, { root: true });

                        dispatch('userList');
                    });
            }
        } else {
            dispatch('notifications/notification', {
                msg: 'Passwords are not the same',
                error: true,
                time: 2000
            }, { root: true });
        }
    },

    changePW: ({ dispatch }, payload) => {
        // change the userinfo
        http.post('changeUserPW', payload)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: response.data,
                    error: false,
                    time: 2000
                }, { root: true });

                dispatch('userList');
            });
    },

    createNewUser: ({ commit, dispatch }, payload) => {
        // check if there is a password
        // if(payload.pw != ''){
        // check if the password is the same as the rewritten password
        // if(payload.pw === payload.rpw){
        // check if the Unum is already in use
        http.post('/checkUnum', {
            unum: payload.unum
        })
            .then((response) => {
                // if something came back that means that the unum is already in use
                if (response.data.length < 1) {
                    // change the userinfo
                    http.post('createNewUser', payload)
                        .then((response) => {
                            dispatch('notifications/notification', {
                                msg: response.data,
                                error: false,
                                time: 800
                            }, { root: true });

                            router.go(-1);
                            dispatch('userList');
                        });
                } else {
                    dispatch('notifications/notification', {
                        msg: 'U number already in use',
                        error: true,
                        time: 800
                    }, { root: true });
                }
            });
        // }else{
        //     dispatch('notifications/notification',{
        //         msg:'Passwords are not the same',
        //         error: true,
        //         time:800
        //     },{root:true});
        // }
        // }else{
        //     dispatch('notifications/notification',{
        //         msg:'password can\'t be empty',
        //         error: true,
        //         time:800
        //     },{root:true});
        // }
    },

    // delete the user
    delUser: ({ commit, dispatch }, payload) => {
        http.post('/delUser', {
            pw: payload,
            id: state.userToDel
        })
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: response.data,
                    error: false,
                    time: 2000
                }, { root: true });

                router.go(-2);
                dispatch('userList');
            });
    },

    addfavtrains: ({ commit }, payload) => {
        var ok = true;
        var trains = state.favtrains;

        for (var i = 0; i < trains.length; i++) {
            if (trains[i].id === payload.id) {
                ok = false;
            }
        }
        if (ok) {
            trains.push(payload);
        }

        commit('favtrains', trains);
    },

    removefavtrain: ({ commit }, payload) => {
        var trains = state.favtrains;

        for (var i = 0; i < trains.length; i++) {
            if (trains[i].id === payload.id) {
                trains.splice(i, 1);
            }
        }
        commit('favtrains', trains);
    },

    saveFavTrains: ({}) => {
        var data = {
            trains: state.favtrains
        }

        http.post('/saveFavTrains', data)
            .then((response) => {
                router.go(-1);
            });
    },

    getFavTrains: ({ commit }) => {
        http.get('/allFavTrains')
            .then((response) => {
                commit('favtrains', response.data);
            });
    },

    sendMailToAddress: ({ dispatch }, payload) => {
        var data = {
            msgBody: payload.body,
            subject: payload.subject,
            address: payload.address
        }

        http.post('/sendMailToAddress', data)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: response.data,
                    error: false,
                    time: 800
                }, { root: true });
            });
    },

    sendMailToId: ({ dispatch }, payload) => {
        var data = {
            msgBody: payload.body,
            subject: payload.subject
        }

        http.post('/sendMailToId', data)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: response.data,
                    error: false,
                    time: 800
                }, { root: true });
            });
    },

    verifyEmail: ({ commit }, payload) => {
        var data = {
            token: payload
        }

        http.post('/verifyemail', data)
            .then((response) => {
                alert('Email verifiziert');
            });
    },

    anb: ({ commit }) => {
        http.get('/getANB')
            .then((response) => {
                commit('anb', response.data);
            });
    },

    acceptanb: ({ commit, state }, payload) => {
        http.get('/acceptANB')
            .then((response) => {
                state.userData.terms = 1;
                router.push(payload.path);
            });
    },

    contact: ({ state, dispatch }, payload) => {
        var dataCopy = {
            msgBody: 'Hallo,<br> Hier ist deine Kopie:<br><br><hr>' + payload.body.replace(/\n/g, '<br>') + '<hr><br>' +
                'Wir werden uns so schnell wie möglich darum kümmern.',
            subject: 'Kopie von "' + payload.subject + '"'
        }

        // get the user data from the user
        var userData = '<br><hr>' +
            state.userData.id + '<br>' +
            state.userData.unum + '<br>' +
            state.userData.fname + '<br>' +
            state.userData.lname + '<br>' +
            state.userData.unum + '<br>' +
            state.userData.email + '<br><hr><br>'

        var dataAdmin = {
            address: 'livio.conzett@gmail.com',
            msgBody: userData + payload.body.replace(/\n/g, '<br>'),
            subject: '1LEAF1 ' + payload.subject
        }

        // send mail to admin
        http.post('/sendMailToAddress', dataAdmin)
            .then((response) => {
                // send copy to user
                http.post('/sendMailToId', dataCopy)
                    .then((response) => {
                        dispatch('notifications/notification', {
                            msg: 'Nachricht gesendet.',
                            error: false,
                            time: 2000
                        }, { root: true });

                        router.push({ name: 'home' });
                    });
            });
    },

    termsok: ({}) => {
        http.get('userTerms')
            .then((response) => {
                if (response.data[0].terms === 1) {
                    router.push({ name: 'home' });
                }
            });
    },

    setLastTime: ({ dispatch }) => {
        // set the new date for the last time on this site
        // it will also calculate and update the amount of different days
        // the user has used the site
        http.get('/setLastusedTime')
            .then((response) => {

            });
    },

    getStaos: ({ commit }) => {
        http.get('/allStao')
            .then((response) => {
                commit('staos', response.data);
                // console.log(response.data);
            });
    },

    getStaos10Min: ({ commit }) => {
        http.get('/stao10min')
            .then((response) => {
                commit('stao10min', response.data);
                //console.log(response.data);
            });
    },

    getStaoInfo: ({ commit }, payload) => {
        http.post('/staoInfo', { id: payload })
            .then((response) => {
                commit('staoInfo', response.data);
                router.push({ name: 'staoinfo' });
            });
    },

    saveStaoInfo: ({ commit, dispatch }, payload) => {
        http.post('/saveStaoInfo', payload)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: 'stao updated',
                    error: false,
                    time: 2000
                }, { root: true });

                dispatch('getStaos');
                // router.go(-1);
            });
    },

    addStao: ({ dispatch }, payload) => {
        if (payload.name === '') {
            dispatch('notifications/notification', {
                    msg: 'add a name for the stao',
                    error: true,
                    time: 2000
                }, { root: true });
        }
        else {
            http.post('/addstao', payload)
                .then((response) => {
                    dispatch('notifications/notification', {
                        msg: 'stao created',
                        error: false,
                        time: 2000
                    }, { root: true });

                    dispatch('getStaos');
                    router.go(-1);
                });
            }
    },

    delStao: ({ dispatch }, payload) => {
        http.post('/delStao', payload)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: response.data,
                    error: false,
                    time: 2000
                }, { root: true });

                router.go(-2);
                dispatch('getStaos');
            });
    },

    sendResetPWEmail: ({ dispatch }, payload) => {
        var data = {
            unum: payload.unum
        }

        http.post('/sendPWForgotMail', data)
            .then((response) => {
                dispatch('notifications/notification', {
                    msg: 'email gesendet',
                    error: false,
                    time: 2000
                }, { root: true });
            });
    },

    resetPW: ({}, payload) => {
        var data = {
            token: payload
        }

        http.post('/userResetPW', data)
            .then((response) => {
                alert('Email mit neuem PW gesendet');
            });
    },
    userMailList: ({ commit }) => {
        http.get('/userMailList')
            .then((response) => {
                // console.log(response.data);

                commit('userMailList', response.data);
            });
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
